var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="datepicker-months"> ';
 _.forEach(months, function (month) { 
__p+=' <a href="#"class="'+
((__t=( month.classList.join(' ') ))==null?'':__t)+
'"data-datepicker-timestamp="'+
((__t=( month.timestamp ))==null?'':__t)+
'"> <span class="datepicker-month-name-long"> '+
((__t=( month.name ))==null?'':_.escape(__t))+
' </span> <span class="datepicker-month-name-short"> '+
((__t=( month.nameShort ))==null?'':_.escape(__t))+
' </span> </a> ';
 }) 
__p+=' </div> <div class="datepicker-years-and-days"> <div class="datepicker-years"> <span> <a href="#"class="'+
((__t=( _.difference(year.classList, ['datepicker-year', 'datepicker-year-add']).join(' ') ))==null?'':__t)+
'"></a> <a class="'+
((__t=( _.difference(year.classList, ['datepicker-year-add', 'datepicker-year-reduce']).join(' ') ))==null?'':__t)+
'"data-datepicker-timestamp="'+
((__t=( year.timestamp ))==null?'':__t)+
'"> '+
((__t=( year.name ))==null?'':_.escape(__t))+
' </a> <a href="#"class="'+
((__t=( _.difference(year.classList, ['datepicker-year', 'datepicker-year-reduce']).join(' ') ))==null?'':__t)+
'"></a> </span> </div> <div class="datepicker-days"> <table class="table-condensed"> <thead> <tr> ';
 _.forEach(dow, function (day) { 
__p+=' <th class="datepicker-dow"> '+
((__t=( day.nameMin ))==null?'':_.escape(__t))+
' </th> ';
 }) 
__p+=' </tr> </thead> <tbody> ';
 _.forEach(weeks, function (week) { 
__p+=' <tr> ';
 _.forEach(week, function (day) { 
__p+=' <td class="'+
((__t=( day.classList.join(' ') ))==null?'':__t)+
'"data-datepicker-timestamp="'+
((__t=( day.timestamp ))==null?'':__t)+
'"> '+
((__t=( day.number ))==null?'':_.escape(__t))+
' </td> ';
 }) 
__p+=' </tr> ';
 }) 
__p+=' </tbody> <tfoot> </tfoot> </table> </div> </div>';
}
return __p;
};
